import { AutogenModelTenfourEmailControl, AutogenRowTenfourEmailControl } from "./autogen/AutogenModelTenfourEmailControl";

export class ModelTenfourEmailControl extends AutogenModelTenfourEmailControl<RowTenfourEmailControl> {
	constructor() {
		super(RowTenfourEmailControl);
	}
}

export class RowTenfourEmailControl extends AutogenRowTenfourEmailControl {
}